import React from 'react';
import { QStack } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import CheckBox from '../CheckBox';

export type DesignControlsPermissionsFormFields = {
  canAccessDesignControls: boolean;
};

const DesignControlsPermissions = () => {
  const { t } = useTranslation();
  return (
    <QStack direction="column">
      <CheckBox
        data-cy="permission-checkbox"
        name="canAccessDesignControls"
        label="design controls"
        text={t('forms.permissions.accessDesignControls')}
      />
    </QStack>
  );
};

export default DesignControlsPermissions;
